import { useState } from 'react';
import { GenericModal } from '@components/generic-modal';
import { Button } from '@components/ui/button';
import { AGREEMENT_BANNER_STORAGE_KEY } from '@constants/local-storage';
import useLocalStorage from '@hooks/use-local-storage';
import { Trans, useTranslation } from 'react-i18next';

function AgreementBanner() {
  const [localStorageAgreementBanner, setLocalStorageAgreementBanner] = useLocalStorage<boolean>(
    AGREEMENT_BANNER_STORAGE_KEY,
    false
  );
  const [showTerms, setShowTerms] = useState<boolean>(false);
  const { t } = useTranslation();
  if (localStorageAgreementBanner) return null;

  return (
    <div className="absolute inset-0 w-full h-full z-10 bg-white">
      <GenericModal
        open={showTerms}
        onOpenChange={setShowTerms}
        title={t('terms.title')}
        description={<p>{t('terms.description')}</p>}
      />
      <div className="w-4/5 rounded-lg p-4 mx-auto mt-2 bg-xircle-main z-10">
        <section>
          <h3 className="font-semibold mb-3">{t('agreement_banner.title')}</h3>
          <p className="whitespace-pre-wrap">
            <Trans i18nKey="agreement_banner.description" t={t}>
              <span
                className="underline inline cursor-pointer text-base"
                onClick={() => setShowTerms(true)}
              >
                s
              </span>
              <a
                className="text-blue-200"
                href="https://www.novartis.de/datenschutzerklaerung-des-medizinischen-infoservices"
                target="_blank"
              />
              <a
                className="text-blue-200"
                href="https://www.novartis.de/datenschutzerklaerung-des-medizinischen-infoservices#chatbot"
                target="_blank"
              />
              <a
                className="text-blue-200"
                href="https://klinischeforschung.novartis.de/infoservice/"
                target="_blank"
              />
              <br />
              <span className="text-[8px] inline-flex h-3 justify-center items-center mr-1" />
            </Trans>
          </p>
        </section>
        <div className="w-full flex justify-center items-center mt-6">
          <Button
            className="bg-xircle-secondary border-none text-lg uppercase shadow-md"
            size="lg"
            onClick={() => setLocalStorageAgreementBanner(true)}
          >
            {t('agreement_banner.agree_button')}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default AgreementBanner;
